import React, { useMemo, useState, useEffect } from 'react';
import StickyTitle from '../components/StickyTitle.js';
import { MaterialReactTable } from 'material-react-table';
import NewVendorForm from '../components/NewVendorForm.js';
import { Button } from '@mui/material';
import axios from 'axios';
import { CSVLink } from "react-csv";
import { useAuth } from '../../AuthContext.js';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const VendorsPage = () => {

  const { userRole } = useAuth()
  const [employee, setEmployee]= useState(true);

  useEffect (()=>{
    if (userRole === "manager") {
      setEmployee(false)
    } else{
      setEmployee(true)
    };
  },[userRole])

  const [isNewVendorFormOpen, setIsNewVendorFormOpen] = useState(false);
  let [selectedRow, setSelectedRow] = useState(null);
  const [selectedRowData, setSelectedRowData] = useState(null);


  const DeleteVendor = async (selectedRowId) => {
    try {
      const response = await axios.delete(`${process.env.REACT_APP_BASE_URL}/vendors/delete_vendor`, {
        data: {
          id: selectedRowId
        }
      });
      if (response.status === 200) {
        toast.success(`Vendor with Id ${selectedRowId} deleted successfully!"`);
      } else {
        toast.error(`Error deleting salesman.`);
      }
    } catch (error) {
      toast.error(`Error deleting salesman.`);
    }
  };
  


  // Function to open the form
  const openNewVendorForm = () => {
    setIsNewVendorFormOpen(true);
  };

  // Function to close the form
  const closeNewVendorForm = () => {
    setIsNewVendorFormOpen(false);
  };

  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchVendors = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/vendors/all_vendors`);
        const responseData = await response.json();
        if (responseData) {
          // console.log(responseData.vendor)
          setData(responseData.vendor);
        }
      } catch (error) {
        // Handle errors here
        console.error("Error fetching data:", error);
      }
    }

    fetchVendors();

  }, [isNewVendorFormOpen]);

  const columns = useMemo(
    () => [
      {
        accessorKey: 'id', //access nested data with dot notation
        header: 'Vendor ID',
        size: 100,
        // Cell: ({ cell }) => (
        //   `ARVN00${cell.getValue()}`
        // ),
      },
      {
        accessorKey: 'vendortitle', //access nested data with dot notation
        header: 'Vendor Title',
        size: 100,
      },
      {
        accessorKey: 'phone',
        header: 'Phone',
        size: 100,
      },
      // {
      //   accessorKey: 'email', //normal accessorKey
      //   header: 'Email',
      //   size: 200,
      // },
      {
        accessorKey: 'address',
        header: 'Address',
        size: 100,
      },
      // {
      //   accessorKey: 'credit',
      //   header: 'Credit',
      //   size: 100,
      // },
      // {
      //   accessorKey: 'debit',
      //   header: 'Debit',
      //   size: 100,
      // },
      {
        accessorKey: 'totalamount',
        header: 'Total $',
        size: 100,
      },
    ],
    [],
  );

  return (
    <>
      <StickyTitle title="Vendors" button_action={openNewVendorForm} button="New Vendor" />
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

      <div className=' px-4 lg:px-16 py-4 lg:py-10 flex flex-col gap-0 overflow-x-auto'>
      <div className="table-filters flex flex-row items-center justify-between mt-3 mb-3">
        <div className='text-2xl ml-2 font-bold font-poppins'>All Vendors</div>
      </div>

      {data ? (<div className="w-full">
        <MaterialReactTable
          // enableRowActions
          enableRowSelection
          columns={columns}
          data={data}
          renderTopToolbarCustomActions={({ table }) => {
            const handleDelete = () => {
              const selectedRows = table.getSelectedRowModel().flatRows;

              if (selectedRows.length === 1) {
                selectedRow = selectedRows[0];
                const selectedRowId = selectedRow.original.id;
                setSelectedRow(selectedRow);
                alert('Deleting Vendor with ID: ' + selectedRowId);
                DeleteVendor(selectedRowId)
              } else {
                alert('Please select a single row to delete.');
              }
            };
            const handleEdit = () => {
              const selectedRows = table.getSelectedRowModel().flatRows;
            
              if (selectedRows.length === 1) {
                const selectedRow = selectedRows[0];
                const selectedRowData = selectedRow.original;
                setSelectedRowData(selectedRowData);
                setIsNewVendorFormOpen(true); // Open the form
              } else {
                alert('Please select a single row to Edit.');
              }
            };
            

            return (
              <div style={{ display: 'flex', gap: '0.5rem' }}>
                <Button
                  color="error"
                  disabled={!table.getIsSomeRowsSelected()}
                  onClick={handleDelete}
                  variant="contained"
                  sx={employee ? {display: 'none'} : { }}
                >
                  Delete
                </Button>
                <Button
                  color="success"
                  disabled={!table.getIsSomeRowsSelected()}
                  onClick={handleEdit}
                  variant="contained"
                >
                  Edit
                </Button>
                <Button
                  color="success"
                  variant="contained"
                >
                  <CSVLink data={data}>Export to CSV</CSVLink>
                </Button>
              </div>
            );
          }}
        />
      </div>) : (null)}
      </div>

      <NewVendorForm isOpen={isNewVendorFormOpen} onClose={closeNewVendorForm} selectedRowData={selectedRowData} />
    </>
  );
};

export default VendorsPage;
